module.exports = __webpack_public_path__ + "static/media/dp.c57c88ea.png";